import { render, staticRenderFns } from "./TemplateConfig.vue?vue&type=template&id=4b66ae3f&scoped=true&"
import script from "./TemplateConfig.vue?vue&type=script&lang=ts&"
export * from "./TemplateConfig.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateConfig.vue?vue&type=style&index=0&id=4b66ae3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b66ae3f",
  null
  
)

export default component.exports